import {selection} from "d3-selection";

var Selection = selection.prototype.constructor;

export default function() {
  return new Selection(this._groups, this._parents);
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-transition/src/transition/selection.js
// module id = ../../../../d3-transition/src/transition/selection.js
// module chunks = 4